import { useRef } from "react"
import { Box } from "@mui/material"
import Tabs, { tabsClasses } from "@mui/material/Tabs"
import { IconButton, ThemeProvider } from "@mui/material"
import { CustomTab, LeftIcon, RightIcon, theme } from "./Atom"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"

export default function DoctorCompensationTabs(props: any) {
  const { fetchByTabId } = props

  const dispatch = useDispatch()
  const tabsRef = useRef<any>(null)

  const handleChange = async (tab: any) => {
    fetchByTabId(tab)
  }

  const selectedDoctorCompensationTab = useSelector((state: any) => {
    return state.doctorCompensation.selectedDoctorCompensationTab
  })

  const doctorCompensationTabs = useSelector((state: any) => {
    return state.doctorCompensation.doctorCompensationTabs
  })

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          flexGrow: 0,
          maxWidth: { xs: "100%", sm: "100%", xl: "100%", md: "100%" },
          bgcolor: "#1A428A",
          display: "flex",
          alignItems: "flex-end",
          color: "primary.main",
          height: "8vh",
        }}
      >
        <Tabs
          ref={tabsRef}
          scrollButtons="auto"
          variant="standard"
          value={selectedDoctorCompensationTab?.index || 0}
          onChange={handleChange}
          aria-label="doctor compensation tabs"
          sx={{
            width: "100%",
            color: "primary.main",
            position: "relative",
            height: "8vh",
          }}
          TabIndicatorProps={{
            style: { display: "none" },
          }}
        >
          {doctorCompensationTabs.map((tab: any, index: any) => (
            <CustomTab
              key={tab?.id}
              label={tab?.name}
              onClick={() => handleChange(tab)}
              // sx={{border:"1px solid red"}}
              style={{
                backgroundColor:
                  selectedDoctorCompensationTab?.index === index
                    ? "#ffffff"
                    : "#1c56ce",
                color:
                  selectedDoctorCompensationTab?.index === index
                    ? "black"
                    : "white",
                marginLeft: index === 0 ? "8px" : "0",
                fontSize:
                  selectedDoctorCompensationTab?.index === index
                    ? "16px"
                    : "16px",
                fontWeight:
                  selectedDoctorCompensationTab?.index === index
                    ? "600"
                    : "400",
                width: "fit-content",
                textTransform: "capitalize",
              }}
            />
          ))}
        </Tabs>
      </Box>
    </ThemeProvider>
  )
}
